import type { PartQuantity } from "../../../components/SupplierInventorySearch/utils/partsCalculationUtils";
import { pickMrpFromOrderItemLike } from "../../../components/SupplierInventorySearch/utils/downloadBucketAvailabilityPdf";
import type { EstimateSplitMode } from "../services/EstimateAllocatorService/types";

export type PreFacetedPartSources = {
  orderItems?: unknown[] | null;
  supplierCancelledItems?: unknown[] | null;
  cboItems?: unknown[] | null;
};

export function getDiscoveryItemsForMode(
  mode: EstimateSplitMode,
  sources: PreFacetedPartSources,
): unknown[] {
  switch (mode) {
    case "reassign":
      return sources.supplierCancelledItems ?? [];
    case "cbo":
      return sources.cboItems ?? [];
    case "assign":
    default:
      return sources.orderItems ?? [];
  }
}

export function buildPreFacetedPartNumbers(
  mode: EstimateSplitMode,
  sources: PreFacetedPartSources,
  getQuantity: (item: unknown) => number,
): PartQuantity[] {
  return getDiscoveryItemsForMode(mode, sources)
    .filter((item) => (getQuantity(item) || 0) > 0)
    .map((item) => {
      const row = item as Record<string, unknown>;
      return {
        partNumber: String(row.partNumber ?? ""),
        rootPartNumber: String(row.rootPartNumber ?? ""),
        quantity: getQuantity(item),
        partName: row.partName as string | undefined,
        partId: row.partId as string | undefined,
        mrp: pickMrpFromOrderItemLike(item),
      };
    });
}
